/**
 * @author      matt@zumper.com (Matthieu Devlin)
 * @copyright   Copyright (c) 2018, Zumper
 * @description Notifications settings related constants
 */

import { parseISO } from 'date-fns'

export const EMAIL = 'email'
export const PUSH = 'push'

export const RECOMMENDED_LISTINGS = 'recommended_listings'
export const PRICE_CHANGES = 'price_changes'
export const MESSAGE_NEXT_STEPS = 'message_next_steps'
export const FAVORITE_NEXT_STEPS = 'favorite_next_steps'
export const TIPS = 'tips'
export const RENT_TRENDS = 'rent_trends'
export const BROWSER_ALERTS = 'web_push'
export const NEW_MESSAGES = 'conversation'

export const SEARCHES = 'searches'
export const SEARCH_FREQUENCY = 'search_frequency'

export const DEFAULT_PUSH_SEARCH_FREQUENCY = 60

// 2100-01-01 is used to denote snoozed forever. Used by blueshift so emails are not sent but we can
// maintain the user's setting if they wish to re-enable.
export const SNOOZED_FOREVER_DATE = parseISO('2100-01-01')

export const ENABLED_OPTIONS = [
  { text: 'On', value: true },
  { text: 'Off', value: false },
] as const

export const PUSH_ALERT_FREQUENCY_OPTIONS = [
  { text: 'Immediately', value: 10 },
  { text: 'Hourly', value: 60 },
  { text: 'Daily', value: 1440 },
] as const

export const SNOOZE_FOR_OPTIONS = [
  { text: '6 months', value: 6 },
  { text: '10 months', value: 10 },
  { text: '12 months', value: 12 },
  { text: 'Stay switched off', value: -1 },
] as const
